import type { StatusTone } from "@/components/ui";

export function formatLabel(value: string): string {
  return value.replaceAll("_", " ");
}

export function creatorTone(status: string): StatusTone {
  switch (status) {
    case "active":
    case "active_creator":
    case "approved":
    case "conditionally_approved":
    case "conditionally_active":
    case "paid":
    case "settled":
    case "completed":
      return "success";
    case "applicant":
    case "draft":
    case "submitted":
    case "under_review":
    case "pending":
    case "pending_approval":
    case "pending_review":
    case "invited":
    case "nominated":
    case "proposed":
    case "scheduled":
    case "eligible":
    case "measured":
    case "processing":
      return "warning";
    case "rejected":
    case "suspended":
    case "revoked":
    case "restricted":
    case "deactivated":
    case "failed":
    case "disputed":
    case "cancelled":
    case "held":
      return "danger";
    default:
      return "neutral";
  }
}
